import { Script, ScriptStrategy, graphql } from "gatsby"
import React from "react"
// import * as styles from "./DatoKlaviyoFormEmbed.module.scss"

type DatoKlaviyoFormEmbedProps = Queries.DatoKlaviyoFormEmbedFragment

const DatoKlaviyoFormEmbed = (props: DatoKlaviyoFormEmbedProps) => {
  // console.log('Rendering DatoKlaviyoFormEmbed', props)
  return (
    <div id={`klaviyo-form-${props.formId}`} className="layout-container">
      <Script
        id="KlaviyoFormEmbed"
        /**
         * load the script when the main thread is free, after hydration
         * https://www.gatsbyjs.com/docs/reference/built-in-components/gatsby-script/#idle-strategy
         */
        strategy={ScriptStrategy.idle}
        type="text/javascript"
        src="https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=RZkcM6"
        onError={() => {
          console.error("Klaviyo Form external JS load failed")
        }}
      />

      <div className={`klaviyo-form-${props.formId}`}></div>
    </div>
  )
}

export default DatoKlaviyoFormEmbed

export const query = graphql`
  fragment DatoKlaviyoFormEmbed on DatoCmsKlaviyoFormEmbed {
    id: originalId # Korjaus daton bugiin, jos käytetään structured textissä
    formId
  }
`
